import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "d-flex justify-content-between" }
const _hoisted_3 = { class: "element-header" }
const _hoisted_4 = { class: "element-box" }
const _hoisted_5 = { class: "form-header mb-4" }
const _hoisted_6 = {
  key: 1,
  class: "table-responsive overflow-auto pt-4"
}
const _hoisted_7 = { class: "table table-striped" }
const _hoisted_8 = { style: {"text-align":"right","padding-right":"30px","min-width":"150px"} }
const _hoisted_9 = { href: "#" }
const _hoisted_10 = { class: "text-right" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]

import officeService from '@/api/Office';
import CreateButton from '@/components/CreateButton.vue';
import EmptyState from '@/components/EmptyState.vue';
import Loader from '@/components/Loader.vue';
import ModalDelete from '@/components/modal/ModalDelete.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import Pagination from '@/components/Pagination.vue';
import PerPage from '@/components/PerPage.vue';
import {CloseToast, ErrorToast, SuccessToast} from '@/components/VueToast';
import router from '@/router';
// @ts-ignore
import {getOfficeDropdown} from '@/shared/dropdowns';
import {downloadFile, getSortIconClass} from '@/shared/functions';
import {piniaEnumsStore} from '@/store/piniaEnumsStore';
import Search from '@/views/App/Office/Search.vue';
import {computed, onMounted, ref} from 'vue';
import {useI18n} from 'vue-i18n';
import {IOfficeFilters, IOfficeList, IPagination} from "@/interfaces/Office/IOffice";
import {ICoachingOverviewFilters} from "@/interfaces/CoachingOverview/ICoachingOverviewFIlters";
import ExcelExportButton from "@/components/ExcelExportButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'List',
  setup(__props) {

const piniaEnumsState = piniaEnumsStore();
const getEnums = computed(() => piniaEnumsState.enums);
const {t} = useI18n();
const isExcelLoaded = ref(false);

const offices = ref<IOfficeList>({
  data: [],
  pagination: {
    total_items: 0,
    total_pages: 0,
    current_page: 1,
    items_per_page: 10,
  } as IPagination,
});

const filters = ref<IOfficeFilters>({
  officeId: '',
  engagementType: '',
  type: '',
  federalState: '',
  orderBy: 'DESC',
  sortBy: '',
  page: 1,
  limit: 10,
});

const showModal = ref(false);
const officeId = ref(0);
const isSearching = ref(false);
const isLoaded = ref(false);
const officeDropdown = ref([]);
const officeTypesDropdown = ref([]);
const federalStatesDropdown = ref([]);
const officeEngagementTypesDropdown = ref([]);

async function getOffices(
    page = 1,
    perPage?: number,
    passedFilters?: ICoachingOverviewFilters
) {
  CloseToast();

  if (passedFilters) {
    isSearching.value = true;
  }
  const perPageRes = offices.value?.pagination?.items_per_page;

  try {
    const {data} = await officeService.getOffices({
      ...(passedFilters ? passedFilters : filters.value),
      page: page,
      limit: perPage ?? perPageRes,
    });

    offices.value = data;
    isSearching.value = false;
  } catch (error) {
    await ErrorToast(error);
    isSearching.value = false;
  }
}

async function deleteOffice() {
  try {
    await officeService.deleteOffice(officeId.value);

    filters.value.officeId = '';
    filters.value.engagementType = '';
    filters.value.type = '';
    filters.value.federalState = '';
    filters.value.orderBy = 'DESC'; // Keep this as 'DESC' if you don't want to change it
    filters.value.sortBy = '';
    showModal.value = false;

    await getOffices();
    SuccessToast(t('general.toasts.delete_success'));
  } catch (error) {
    await ErrorToast(error);
  }
}

function getIconClass(key: string) {
  return getSortIconClass(filters.value, key);
}

function sortBy(key: string) {
  filters.value = {
    ...filters.value,
    sortBy: key,
    orderBy:
        filters.value.orderBy === 'DESC' ||
        filters.value.sortBy !== key ? 'ASC' : 'DESC',
  };
  getOffices();
}

function updateModal(value: boolean) {
  CloseToast();
  showModal.value = value;
}

function deleteModal(id: number) {
  CloseToast();
  officeId.value = id;
  showModal.value = true;
}

async function getOfficeEnumDropdowns() {
  federalStatesDropdown.value = getEnums.value?.federalStates || [];
  officeEngagementTypesDropdown.value = getEnums.value?.officeEngagementTypes || [];
  officeTypesDropdown.value = getEnums.value?.officeTypes || [];
}


async function getExcelExport() {
  await downloadFile('/office/excel-export', undefined,
      filters.value,
      false,
      "GET",
      isExcelLoaded
  )
}

onMounted(async () => {
  await Promise.all([
    getOfficeEnumDropdowns(),
    getOfficeDropdown(officeDropdown, t),
    getOffices(),
  ]);

  isLoaded.value = true;
});



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PageTemplate, null, {
    default: _withCtx(() => [
      (!isLoaded.value)
        ? (_openBlock(), _createBlock(Loader, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("h6", _hoisted_3, _toDisplayString(_ctx.$t('office.title')), 1),
              _createVNode(CreateButton, {
                label: _ctx.$t('office.create'),
                to: { name: 'officeForm' }
              }, null, 8, ["label"])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.$t('office.list')), 1),
              _createVNode(Search, {
                filters: filters.value,
                loading: isSearching.value,
                "office-dropdown": officeDropdown.value,
                federalStatesDropdown: federalStatesDropdown.value,
                officeTypesDropdown: officeTypesDropdown.value,
                officeEngagementTypesDropdown: officeEngagementTypesDropdown.value,
                onSearch: getOffices
              }, null, 8, ["filters", "loading", "office-dropdown", "federalStatesDropdown", "officeTypesDropdown", "officeEngagementTypesDropdown"]),
              _createVNode(PerPage, {
                values: [10, 25, 50, 100],
                "onUpdate:perPage": getOffices
              }),
              _createVNode(ExcelExportButton, {
                style: {"margin-right":"15px"},
                label: _ctx.$t('general.excel_export'),
                loading: isExcelLoaded.value,
                onClick: getExcelExport
              }, null, 8, ["label", "loading"]),
              (!offices.value.data?.length)
                ? (_openBlock(), _createBlock(EmptyState, {
                    key: 0,
                    icon: "fa-building",
                    title: "Keine Standorte gefunden",
                    subtitle: "Es wurden keine Standorte gefunden, die Ihren Suchkriterien entsprechen."
                  }))
                : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("table", _hoisted_7, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", null, [
                            _createElementVNode("a", {
                              href: "#",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (sortBy('name')))
                            }, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t('general.office_name')), 1),
                              _createElementVNode("i", {
                                class: _normalizeClass(getIconClass('name'))
                              }, null, 2)
                            ])
                          ]),
                          _createElementVNode("th", null, [
                            _createElementVNode("a", {
                              href: "#",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (sortBy('address')))
                            }, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t('general.street')), 1),
                              _createElementVNode("i", {
                                class: _normalizeClass(getIconClass('address'))
                              }, null, 2)
                            ])
                          ]),
                          _createElementVNode("th", null, [
                            _createElementVNode("a", {
                              href: "#",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (sortBy('zip'))),
                              style: {"min-width":"200px"}
                            }, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t('general.postal_code')), 1),
                              _createElementVNode("i", {
                                class: _normalizeClass(getIconClass('zip'))
                              }, null, 2)
                            ])
                          ]),
                          _createElementVNode("th", null, [
                            _createElementVNode("a", {
                              href: "#",
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (sortBy('city'))),
                              style: {"min-width":"200px"}
                            }, [
                              _createTextVNode(_toDisplayString(_ctx.$t('general.city')) + " ", 1),
                              _createElementVNode("i", {
                                class: _normalizeClass(getIconClass('city'))
                              }, null, 2)
                            ])
                          ]),
                          _createElementVNode("th", null, [
                            _createElementVNode("a", {
                              href: "#",
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (sortBy('engagementType')))
                            }, [
                              _createTextVNode(_toDisplayString(_ctx.$t('general.office_engagement_type')) + " ", 1),
                              _createElementVNode("i", {
                                class: _normalizeClass(getIconClass('engagementType'))
                              }, null, 2)
                            ])
                          ]),
                          _createElementVNode("th", null, [
                            _createElementVNode("a", {
                              href: "#",
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (sortBy('federalState')))
                            }, [
                              _createTextVNode(_toDisplayString(_ctx.$t('general.federal_state')) + " ", 1),
                              _createElementVNode("i", {
                                class: _normalizeClass(getIconClass('federalState'))
                              }, null, 2)
                            ])
                          ]),
                          _createElementVNode("th", null, [
                            _createElementVNode("a", {
                              href: "#",
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (sortBy('region')))
                            }, [
                              _createTextVNode(_toDisplayString(_ctx.$t('general.region')) + " ", 1),
                              _createElementVNode("i", {
                                class: _normalizeClass(getIconClass('region'))
                              }, null, 2)
                            ])
                          ]),
                          _createElementVNode("th", _hoisted_8, [
                            _createElementVNode("a", _hoisted_9, _toDisplayString(_ctx.$t('general.actions')), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(offices.value.data, (office) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: office.id
                          }, [
                            _createElementVNode("td", null, _toDisplayString(office?.name), 1),
                            _createElementVNode("td", null, _toDisplayString(office?.address), 1),
                            _createElementVNode("td", null, _toDisplayString(office?.zip), 1),
                            _createElementVNode("td", null, _toDisplayString(office?.city), 1),
                            _createElementVNode("td", null, _toDisplayString(office?.engagementTypeTranslation), 1),
                            _createElementVNode("td", null, _toDisplayString(office?.federalStateTranslation), 1),
                            _createElementVNode("td", null, _toDisplayString(office?.regionTranslation), 1),
                            _createElementVNode("td", _hoisted_10, [
                              _createElementVNode("button", {
                                class: "btn btn-primary",
                                onClick: ($event: any) => (_unref(router).push({name: 'officeForm', params: {
                          id: office?.id
                        } }))
                              }, [...(_cache[7] || (_cache[7] = [
                                _createElementVNode("i", { class: "os-icon os-icon-edit" }, null, -1)
                              ]))], 8, _hoisted_11),
                              _createElementVNode("button", {
                                class: "btn btn-danger ml-2",
                                onClick: ($event: any) => (deleteModal(office.id!))
                              }, [...(_cache[8] || (_cache[8] = [
                                _createElementVNode("i", { class: "os-icon os-icon-trash" }, null, -1)
                              ]))], 8, _hoisted_12)
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ])),
              (offices.value?.pagination?.total_pages > 1)
                ? (_openBlock(), _createBlock(Pagination, {
                    key: 2,
                    totalPages: offices.value?.pagination?.total_pages,
                    currentPage: offices.value?.pagination?.current_page,
                    totalItems: offices.value?.pagination?.total_items,
                    perPage: offices.value?.pagination?.items_per_page,
                    onPagechanged: getOffices
                  }, null, 8, ["totalPages", "currentPage", "totalItems", "perPage"]))
                : _createCommentVNode("", true)
            ])
          ])),
      _createVNode(ModalDelete, {
        "onUpdate:modelValue": updateModal,
        modelValue: showModal.value,
        header: _unref(t)('general.delete_item_header'),
        onDelete: deleteOffice
      }, null, 8, ["modelValue", "header"])
    ]),
    _: 1
  }))
}
}

})